/* @flow */

import * as React from 'react';
import glamorous from 'glamorous';

type Props = {
  hideLabel?: boolean,
  value: number,
};

const Wrapper = glamorous.div(({ theme }) => ({
  fontSize: theme.fontSize.xxsmall,
}));

const Line = glamorous.div(({ theme }) => ({
  position: 'absolute',
  top: 0,
  height: 2,
  width: '100%',
  backgroundColor: theme.color.basis6,
}));

const TopLine = glamorous(Line)(({ theme }) => ({
  backgroundColor: theme.color.primary,
}));

const LineContainer = glamorous.div({
  position: 'relative',
});

function LineGraph({ hideLabel, value }: Props) {
  return (
    <Wrapper>
      {!hideLabel && `${value}%`}
      <LineContainer>
        <Line />
        <TopLine
          style={{
            transform: `scaleX(${value / 100})`,
            transformOrigin: 'left',
          }}
        />
      </LineContainer>
    </Wrapper>
  );
}

LineGraph.defaultProps = {
  hideLabel: false,
};

export default LineGraph;
